import {
  SHOW_CUSTOM_POPUP,
  HIDE_POPUP,
} from '../constants';

export function showPopup(subtype, options, noTimeout) {
  return {
    type: SHOW_CUSTOM_POPUP,
    subtype,
    options,
    noTimeout,
  };
}

export function hidePopup() {
  return {
    type: HIDE_POPUP,
  };
}



// WEBPACK FOOTER //
// ./src/actions/NotificationPopupActions.js